
import bigBlueLogo from "../Assets/Logos/bbt.webp";
import salvationArmyLogo from "../Assets/Logos/salvationArmy.webp";
import saintPatsLogo from "../Assets/Logos/splogo.png"
const partnersData = [
    {
      name: 'Big Blue Theatre',
      description: "Big Blue Theatre's mission is to support the work of artists through the creation of new theatrical work. This includes plays, concerts, improv, and any other form of theatrical entertainment.",
      logo: bigBlueLogo,
      type: "Theatre Company",
      link: "https://www.bigbluetheatre.org/",
      location: "Woodbury, MN",
      background: "var(--surface-light)"
    },
    {
      name: "The Salvation Army",
      description: "The Salvation Army, an international movement, is an evangelical part of the universal Christian Church. Its message is based on the Bible. Its ministry is motivated by the love of God. Its mission is to preach the gospel of Jesus Christ and to meet human needs in His name without discrimination.",
      logo: salvationArmyLogo,
      type: "Evangelical Organization",
      link: "https://www.salvationarmyusa.org/mn/saint-paul/woodlynn-ave-corps/",
      location: "Many Locations, U.S.",
      background: "white"
    },
    {
      name: "Saint Patrick Parish",
      description: "To joyfully proclaim, share, and celebrate the love and mercy of Jesus Christ through Word, Sacrament, prayer, and ministry.",
      logo: saintPatsLogo,
      type: "Catholic Church | School",
      link: "https://www.stpatrickofhudson.org/",
      location: "1500 Vine Street, Hudson, WI 54016",
      background: "white"
    },
  ]

  export default partnersData;